import SuperAdminLayout from "SuperAdmin/SuperAdminLayout/SuperAdminLayout"
import SettingsNav from "SuperAdmin/SuperAdminNav/SettingsNav"



const NewPasswordPageSettings = () =>{
    return<>
    <SuperAdminLayout>

        <SettingsNav />

        <h1> New Password Page Settings</h1>


    </SuperAdminLayout>
    
    </>
}
export default NewPasswordPageSettings